import {components} from "react-select";
import React from "react";

const CountySingleValue = props => {
  return <components.SingleValue {...props}>
    {/* eslint-disable-next-line react/prop-types */}
    {props.data.county}
    {/* eslint-disable-next-line react/prop-types */}
    {props.data.state ? <small className="text-muted"> | {props.data.state}</small> : null}
  </components.SingleValue>
}

export default CountySingleValue;
